import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ImportCsvSearchSchema } from '@/features/import-csv/zod-schemas';
import { orpcClient } from '@/lib/api/orpc/client';
import { isAccountCsvImportBlocked } from '@/routes/_staff/software/_layout/library/-query/training';
import { getSoftware } from '../_$id/-query/api';
export const Route = createFileRoute('/_staff/software/$id/import-csv')({
  validateSearch: zodValidator(ImportCsvSearchSchema),
  loader: async ({
    params
  }) => {
    const software = await getSoftware(params.id);
    if (software.appIntegrationId != null) {
      const settings = await orpcClient.software.integrationSettings({
        softwareId: params.id
      });
      if (isAccountCsvImportBlocked(settings.training?.enabled)) {
        throw redirect({
          to: '/software/$id/detail',
          params: {
            id: params.id
          }
        });
      }
    }
    return software;
  }
});